import React from 'react';
import { Template } from '../components/template';
import { SectionTopImage } from '../components/section-top-image';
import { SectionSimpleText } from '../components/section-simple-text';
import "./samples.css";
import { SectionOurProjects } from '../components/section-our-projects';
import { Footer } from '../components/footer';
import { SectionContactUs } from '../components/section-contact-us';
import ContextHelper from '../client/ContextHelper';

export default class Samples extends React.Component {

    componentDidMount(){
        const element = document.querySelector(".project");
        if(!element){
            return;
        }
        let top = element.getBoundingClientRect().top;
        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });
    }

    render(){
        const {seo} = this.props.pageContext;
        const {title_1, title_2} = ContextHelper.getPageSpecificContext(this.props);
        const {top_title, top_subtitle, api_host, samples} = ContextHelper.getPageCommonContext(this.props);

        return (
            <Template seo={seo} className="samples-page">
                <SectionTopImage
                    title = {top_title}
                    subtitle = {top_subtitle}
                />
                <SectionSimpleText
                    title={title_1}
                    text={title_2}
                />
                <SectionOurProjects projects={samples}/>
                <SectionContactUs
                    api_host={api_host}/>
                <Footer/>
            </Template>
        )
    }
}